import axios from "axios";
import { getBackendUrl } from "./GlobalConstant";

const csrfClient = axios.create({
  withCredentials: true,
});

const axiosClient = axios.create({
  withCredentials: true,
});

let csrfTokenPromise = null;

function isMutatingRequest(config) {
  const method = (config.method || "get").toLowerCase();
  return !["get", "head", "options"].includes(method);
}

function needsCsrfProtection() {
  if (
    typeof window !== "undefined" &&
    window.location.pathname.startsWith("/classflex_dev")
  ) {
    return true;
  }

  return (process.env.REACT_APP_ENV || "").trim() !== "production";
}

async function getCsrfToken(forceRefresh = false) {
  if (!forceRefresh && csrfTokenPromise) {
    return csrfTokenPromise;
  }

  csrfTokenPromise = csrfClient
    .get(`${getBackendUrl()}/csrf-token`)
    .then((response) => {
      csrfTokenPromise = null;
      return response.data.csrfToken;
    })
    .catch((error) => {
      csrfTokenPromise = null;
      throw error;
    });

  return csrfTokenPromise;
}

axiosClient.interceptors.request.use(async (config) => {
  config.baseURL = getBackendUrl();

  const token = localStorage.getItem("ACCESS_TOKEN");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (needsCsrfProtection() && isMutatingRequest(config)) {
    const csrfToken = await getCsrfToken(true);
    if (csrfToken) {
      config.headers["X-CSRF-TOKEN"] = csrfToken;
    }
  }

  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response, config } = error;

    if (
      response?.status === 419 &&
      config &&
      !config._csrfRetried &&
      needsCsrfProtection()
    ) {
      config._csrfRetried = true;
      const csrfToken = await getCsrfToken(true);
      if (csrfToken) {
        config.headers["X-CSRF-TOKEN"] = csrfToken;
      }
      return axiosClient(config);
    }

    if (response && response.status === 401) {
      localStorage.removeItem("ACCESS_TOKEN");
    }

    throw error;
  }
);

export default axiosClient;
